import { memo, useEffect } from 'react'
import { ENV } from '@/utils'
import { useAnalyticsProviderController } from './AnalyticsProvider.controller'

const GTM_SCRIPT_ID = 'gtm'

const AnalyticsProvider = () => {
  useAnalyticsProviderController()

  useEffect(() => {
    if (!ENV.GOOGLE_TAG_MANAGER_ID) return
    if (typeof window === 'undefined') return
    if (document.getElementById(GTM_SCRIPT_ID)) return

    // Bootstrap Google Tag Manager: initialise the dataLayer and inject the
    // loader script imperatively (Vite has no <Script> component like Next.js).
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })

    const script = document.createElement('script')
    script.id = GTM_SCRIPT_ID
    script.async = true
    script.src = `https://www.googletagmanager.com/gtm.js?id=${ENV.GOOGLE_TAG_MANAGER_ID}`
    document.head.appendChild(script)
  }, [])

  return null
}

export default memo(AnalyticsProvider)
